// Registrierung des Bereichs „Suche" für die Andockstelle (extras/index.tsx bindet sie ein).
import type { ExtraMenuItem, ExtraRoute } from '../index';
import { ChannelSearchButton } from './ChannelSearchButton';
import { SearchPage } from './SearchPage';

export const searchRoutes: ExtraRoute[] = [{ path: '/search', element: SearchPage }];

export const searchMenuItems: ExtraMenuItem[] = [
  { id: 'search', label: 'Suchen', slot: 'channelHeader', component: ChannelSearchButton, display: 'panel' },
  { id: 'search-page', label: 'Suche', slot: 'userMenu', to: '/search' },
];

export { ChannelSearchButton, SearchPage };
